import "./src/styles/global.css";
import CustomLayout from "./wrapPageElement";

export const wrapPageElement = CustomLayout
